import { api, escapeHtml } from './http';

export function pageLayout(title: string, body: string, options: { admin?: boolean; publicNav?: boolean; wide?: boolean; compact?: boolean; showAbout?: boolean; showHeader?: boolean; showHeading?: boolean; eyebrow?: string } = {}): string {
  const brandContent = `<span class="brand-mark" aria-hidden="true">P</span>
        <span><strong>Petrovitsky Park Open Space &amp; Trail</strong><small>Community Survey</small></span>`;
  const brand = options.showAbout === false
    ? `<a class="brand" href="/" aria-label="Petrovitsky Park Open Space and Trail Community Survey home">${brandContent}</a>`
    : `<button class="brand" type="button" data-about-open aria-label="About the Petrovitsky Park Open Space and Trail Community Survey">${brandContent}</button>`;
  return `
    ${options.showHeader === false ? '' : `<header class="site-header${options.publicNav ? ' public-site-header' : ''}">
      ${options.publicNav ? `<nav class="admin-nav public-nav" aria-label="Survey results">
        <a href="/">Results</a>
        <a href="/results-map">Map</a>
        <a href="/bias">Bias Measurements</a>
        <a href="/example">Example</a>
        <a href="/analysis">Analysis</a>
      </nav>` : `${brand}
      ${options.admin ? `<nav class="admin-nav" aria-label="Admin tools">
        <a href="/results-dashboard">Results</a>
        <a href="/results-map">Result map</a>
        <a href="/bias">Bias</a>
        <a href="/generate-codes">Codes</a>
        <a href="/given-tracker">Visit map</a>
        <button class="link-button" id="signOutButton" type="button">Sign out</button>
      </nav>` : ''}`}
    </header>`}
    <main class="page-shell${options.wide ? ' page-shell-wide' : ''}${options.compact ? ' page-shell-compact' : ''}">
      ${options.showHeading === false ? '' : `<div class="page-heading"><p class="eyebrow">${escapeHtml(options.eyebrow ?? 'Petrovitsky Park Open Space')}</p><h1>${escapeHtml(title)}</h1></div>`}
      ${body}
    </main>
    <footer class="site-footer"><span>Petrovitsky Park Open Space &amp; Trail Community Survey</span>${options.showAbout === false ? '' : '<button class="footer-link-button" type="button" data-about-open>About</button>'}</footer>
    ${options.showAbout === false ? '' : `<dialog class="about-dialog" data-about-dialog aria-labelledby="aboutDialogTitle">
      <div class="about-dialog-content">
        <button class="about-dialog-close" type="button" data-about-close aria-label="Close About dialog">×</button>
        <p class="eyebrow">About this survey</p>
        <h2 id="aboutDialogTitle">An independent community survey</h2>
        <p>This is an independent survey organized by concerned citizens. It is not affiliated with King County Parks &amp; Recreation.</p>
        <p>We are conducting it because King County has refused to conduct its own scientifically accurate survey of the community.</p>
        <button class="secondary-button" type="button" data-about-close>Close</button>
      </div>
    </dialog>`}`;
}

export async function renderProtectedPage(
  root: HTMLElement,
  title: string,
  renderContent: () => Promise<void> | void,
  options: { wide?: boolean; compact?: boolean; showHeading?: boolean } = {},
): Promise<void> {
  const response = await fetch('/api/admin/session');
  if (!response.ok) {
    root.innerHTML = pageLayout(title, `
      <section class="card auth-card">
        <h2>Enter the private passcode</h2>
        <p>This tool is limited to survey organizers.</p>
        <form id="adminLoginForm" class="stack-form">
          <label>Passcode<input name="passcode" type="password" autocomplete="current-password" required autofocus></label>
          <button class="primary-button" type="submit">Continue</button>
          <p class="form-message" id="loginMessage" role="alert"></p>
        </form>
      </section>`, { showAbout: false, showHeading: options.showHeading, compact: options.compact });
    root.querySelector<HTMLFormElement>('#adminLoginForm')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget as HTMLFormElement;
      const message = root.querySelector<HTMLElement>('#loginMessage')!;
      const button = form.querySelector<HTMLButtonElement>('button')!;
      button.disabled = true;
      try {
        await api('/api/admin/session', { method: 'POST', body: JSON.stringify({ passcode: new FormData(form).get('passcode') }) });
        await renderProtectedPage(root, title, renderContent, options);
      } catch (error) {
        message.textContent = error instanceof Error ? error.message : 'Could not sign in.';
        button.disabled = false;
      }
    });
    return;
  }

  root.innerHTML = pageLayout(title, '<div id="protectedContent"></div>', { admin: true, wide: options.wide, compact: options.compact, showAbout: false, showHeading: options.showHeading });
  root.querySelector('#signOutButton')?.addEventListener('click', async () => {
    await api('/api/admin/session', { method: 'DELETE' });
    await renderProtectedPage(root, title, renderContent, options);
  });
  await renderContent();
}
